module.exports = __webpack_public_path__ + "static/favicons/favicon-32x32-d941ca46b56e608cb9627e7e4394f7e0.png";